/* eslint-disable @typescript-eslint/no-unused-vars */
import type { SettingAPIInterface } from './api-switcher'
import { client } from './client'
import { responseDataConverter } from './converters'

type NotificationSetting = {
  share: boolean
  share_reaction: boolean
  share_add_photo: boolean
  share_name_change: boolean
  share_type_change: boolean
  dm: boolean
  dm_receive: boolean
  dm_reaction: boolean
}

export const SettingAPI: SettingAPIInterface = {
  getNotificationSettings: (signal?: AbortSignal) =>
    // TODO: No direct API endpoint for notification settings
    Promise.resolve({
      data: {
        share: true,
        share_reaction: true,
        share_add_photo: true,
        share_name_change: true,
        share_type_change: true,
        dm: true,
        dm_receive: true,
        dm_reaction: true
      },
      response: new Response()
    }),

  updateNotificationSettings: (settings: NotificationSetting) =>
    // TODO: No direct API endpoint for updating notification settings
    Promise.resolve({
      error: { code: 0, message: 'Not implemented' },
      response: new Response()
    }),

  updateClientApplication: (id: string, is_upload: boolean) =>
    // TODO: No direct API endpoint for updating client application
    Promise.resolve({
      error: { code: 0, message: 'Not implemented' },
      response: new Response()
    }),

  deleteClientApplication: (id: string) =>
    // TODO: No direct API endpoint for deleting client application
    Promise.resolve({
      error: { code: 0, message: 'Not implemented' },
      response: new Response()
    })
}